import { downloadInternalDraftAttachment } from '../../../api/internalDraft';
import { InternalDraft } from '../../../types/internalDraft';
import ApprovalStampBox from '../ApprovalStampBox';
import { PreviewAttachmentList } from './previewShared';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';

interface Props {
  detail: InternalDraft;
}

function InternalDraftPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <div>
            <h3 style={{ margin: 0 }}>내부 기안서</h3>
          </div>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            문서번호
            <input value={detail.draftNo || '-'} readOnly />
          </label>
          <label className="is-span-2">
            제목 *
            <input value={detail.title || ''} readOnly />
          </label>
          <label className="is-span-2">
            내용
            <textarea rows={8} value={detail.content || ''} readOnly />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={3} value={detail.remark || ''} readOnly />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) =>
            void downloadInternalDraftAttachment(
              detail.internalDraftId,
              file.attachmentId,
              file.fileName
            ).catch(() => undefined)
          }
        />
      </section>
    </div>
  );
}

export default InternalDraftPreviewView;
